import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { ResearchAuthService } from './auth/auth.service';
import { ResearchAuthGuard } from './auth/auth.guard';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CredentialInterceptor } from './interceptors/credential.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { Router } from '@angular/router';

@NgModule({
    declarations: [],
    imports: [HttpClientModule],
    exports: []
})
export class ResearchAuthModule {

    public static withInterceptors(providers: Provider[]): ModuleWithProviders {
        return ResearchAuthModule.configureProviders(providers);
    }

    public static defaultInterceptors(): Provider[] {
        return [{
            provide: HTTP_INTERCEPTORS,
            useClass: CredentialInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useFactory: ResearchAuthModule.httpErrorFactory,
            deps: [ResearchAuthService, Router],
            multi: true
        }];
    }

    public static httpErrorFactory(authService: ResearchAuthService, router: Router) {
        return new ErrorInterceptor(authService, router);
    }

    private static configureProviders(providers: Provider[]) {
        return {
            ngModule: ResearchAuthModule,
            providers: [
                ResearchAuthService,
                ResearchAuthGuard,
                ...providers
            ]
        };
    }
}
